import get from 'lodash/get';
import * as types from './constants';
const defaultState = {
  loading: false,
  loadingInModal: false,
  error: null,
  errorInModal: null,
  activeStep: 0,
  application: {},
  documents: [],
  settlement: [],
  sessionStartTime: '',
  lookups: {},
  property: [],
  selectedProperties: [],
  multipleProperties: {
    properties: [],
    totalPages: 1,
  },
  applicationId: null,
  applicationType: '',
  description: '',
  disputeDetail: {
    disputeTypeId: '',
    disputeSectorId: '',
    disputeSubjectId: '',
    disputeCategoryId: '',
  },
  manualAddress: {
    municipalityId: null,
    districtID: null,
    communityID: null,
    ownerEid: '',
    streetName: '',
    entranceNumber: '',
    propertyAddress: '',
    onwaniAddress: '',
  },
  manualProperties: [],
  plaintiffTypeData: {
    type: '',
    subType: '',
  },
  defendantTypeData: {
    type: '',
    subType: '',
  },
  plaintiffList: [],
  defendantList: [],
  plaintiffs: [],
  defendants: [],
  demands: [],
  plotIds: [],
  disputedProperties: [],
  totalDemandValue: 17000,
  disputeLawFirmsPlaintiff: [],
  disputeLawFirmDefendant: [],
  representativeDetails: [],
  lawFirmInfoFields: {},
  represntativeDetails: {},
  fetchedUser: {},
  PropertyOwnerByEid: {},
  activeUpdatingLawFirmId: null,
};

export default function RegisterDisputeReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.REGISTER_DISPUTE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.REGISTER_DISPUTE_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.REGISTER_DISPUTE_LOADING_IN_MODAL:
      return {
        ...state,
        loading: false,
        loadingInModal: true,
        error: null,
      };

    case types.CLEAR_REGISTER_DISPUTE_APPLICATION_ERROR:
      return {
        ...state,
        error: null,
      };

    case types.FETCH_APPLICATION_REGISTER_DISPUTE_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        contractDetails: get(action.payload, 'contractDetails', {}),
        disputeDetail: get(action.payload, 'disputeDetail', {}),
        disputeLawFirmsPlaintiff: get(action.payload, 'disputeLawFirmsPlaintiff', []),
        disputeLawFirmDefendant: get(action.payload, 'disputeLawFirmDefendant', []),
        representativeDetails: get(action.payload, 'representativeDetails', []),
        plaintiffs: get(action.payload, 'plaintiffs', []),
        defendants: get(action.payload, 'defendants', []),
        plotIds: action?.payload?.application?.disputeProperties?.plotIds || [],
        disputedProperties: action?.payload?.application?.disputeProperties?.properties || [],
        manualProperties: action?.payload?.application?.disputeProperties?.manualProperties ?? [],
        demands: get(action.payload, 'demands', []),
        description: get(action.payload, 'description', []),
        settlement: get(action.payload, 'settlement', []),
        sessionStartTime: get(action.payload, 'sessionStartTime', []),
        fetchedUser: {},
      };
    case types.FETCH_PROPERTY_REGISTER_DISPUTE_SUCCESS:
      return {
        ...state,
        loading: false,
        property: get(action.payload, 'property', {}),
      };
    case types.UPDATE_DEMANDS_DATA:
      return {
        ...state,
        loading: false,
        demands: get(action.payload, 'demands', []),
      };

    case types.FETCH_DOCUMENTS_REGISTER_DISPUTE_SUCCESS:
      return {
        ...state,
        loading: false,
        documents: get(action.payload, 'documents', []),
      };

    case types.INITIATE_REGISTER_DISPUTE_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        contractDetails: get(action.payload, 'contractDetails', {}),
      };

    case types.CHANGE_REGISTER_DISPUTE_STEP:
      return {
        ...state,
        activeStep: get(action.payload, 'step'),
      };

    case types.DOWNLOAD_DOCUMENT_REGISTER_DISPUTE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.SAVE_APPLICATION_REGISTER_DISPUTE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.REGISTER_DISPUTE_CANCEL_APPLICATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }

    case types.CHECKOUT_REGISTER_DISPUTE_APPLICATION:
      return {
        ...state,
        loading: true,
      };
    case types.CHECKOUT_REGISTER_DISPUTE_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        activeStep: 0,
      };

    // post flow

    case types.APPROVAL_REGISTER_DISPUTE_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case types.POST_RETURN_REGISTER_DISPUTE_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case types.REGISTER_DISPUTE_CLEAR_DATA:
      return defaultState;

    case types.DOWNLOAD_TRANSFEER_REGISTER_DISPUTE_CONTRACT_DOCUMENT_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case types.DOWNLOAD_REGISTER_DISPUTE_CONTRACT_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.UPLOAD_REGISTER_DISPUTE_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };

    case types.FETCH_REGISTER_DISPUTE_PROPERTY_CONTRACT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        PropertyContractDetails: action.payload,
      };

    case types.UPDATE_DISPUTE_TYPE_DATA:
      return {
        ...state,
        disputeDetail: {
          ...state.disputeDetail,
          ...action.payload,
        },
      };
    case types.UPDATE_SELECTED_PROPERTY:
      return {
        ...state,
        selectedProperties: action.payload,
      };

    case types.RESET_MANUAL_ADDRESS:
      return {
        ...state,
        manualAddress: defaultState.manualAddress,
      };

    case types.UPDATE_MANUAL_ADDRESS:
      return {
        ...state,
        manualAddress: {
          ...state.manualAddress,
          ...action.payload,
        },
      };
    case types.UPDATE_MANUAL_PROPERTIES:
      return {
        ...state,
        manualProperties: action.payload,
      };
    case types.REGISTER_DISPUTE_ERROR_IN_MODAL:
      return {
        ...state,
        loading: false,
        loadingInModal: false,
        errorInModal: action.payload,
      };
    case types.UPDATE_PLAINTIFF_DEFENDANT_TYPE:
      const updateType = state.activeStep === 2 ? 'plaintiffTypeData' : 'defendantTypeData';
      return {
        ...state,
        errorInModal: null,
        [updateType]: {
          ...state[updateType],
          ...action.payload,
        },
      };

    case types.FETCH_PLAINTIFF_SUCCESS:
      return {
        ...state,
        loading: false,
        plaintiffList: get(action.payload, 'plaintiffList', []),
      };
    case types.FETCH_DEFENDANT_SUCCESS:
      return {
        ...state,
        loading: false,
        defendantList: get(action.payload, 'defendantList', []),
      };
    case types.UPDATE_SELECTED_PLAINTIFFS_DEFENDANTS:
      const updateSelected = state.activeStep === 2 ? 'plaintiffs' : 'defendants';
      return {
        ...state,
        loading: false,
        fetchedUser: {},
        [updateSelected]: action.payload,
      };
    case types.UPDATE_PLAINTIFFS_DEFENDANTS:
      const updateDataFor = state.activeStep === 2 ? 'plaintiffList' : 'defendantList';
      return {
        ...state,
        [updateDataFor]: [...state[updateDataFor], action.payload],
      };
    case types.REMOVE_PLAINTIFFS_DEFENDANTS:
      const updateDataForType = state.activeStep === 2 ? 'plaintiffList' : 'defendantList';
      const prevStateData = state[updateDataForType] && [...state[updateDataForType]];
      const delIndex =
        action.payload?.licenseNumber && action.payload?.licenseNumber !== null
          ? prevStateData.findIndex(item => action.payload?.licenseNumber === item?.licenseNumber)
          : action.payload?.eid && action.payload?.eid !== null
          ? prevStateData.findIndex(item => action.payload?.eid === item?.eid)
          : prevStateData.findIndex(item => action.payload?.email === item?.email);
      prevStateData?.splice(delIndex, 1);
      const updateSelectedData = state.activeStep === 2 ? 'plaintiffs' : 'defendants';
      const prevStateSelData = state[updateSelectedData] && [...state[updateSelectedData]];
      const delIndexSelected =
        action.payload?.licenseNumber && action.payload?.licenseNumber !== null
          ? prevStateSelData.findIndex(item => action.payload?.licenseNumber === item?.licenseNumber)
          : action.payload?.eid && action.payload?.eid !== null
          ? prevStateSelData.findIndex(item => action.payload?.eid === item?.eid)
          : prevStateSelData.findIndex(item => action.payload?.email === item?.email);
      prevStateSelData?.splice(delIndexSelected, 1);
      return {
        ...state,
        loading: false,
        [updateDataForType]: [...prevStateData],
        [updateSelectedData]: [...prevStateSelData],
      };
    case types.UPDATE_FETCHED_USER:
      return {
        ...state,
        loadingInModal: false,
        errorInModal: null,
        fetchedUser: Object.keys(action.payload).length === 0 ? {} : { ...state.fetchedUser, ...action.payload },
      };
    case types.ADD_NEW_LAW_FIRM_INFO:
      const currentUpdatedPropertyName =
        action.payload.currentStep === 2 ? 'disputeLawFirmsPlaintiff' : 'disputeLawFirmDefendant';
      return {
        ...state,
        loading: false,
        loadingInModal: false,
        errorInModal: null,
        [currentUpdatedPropertyName]: [...state[currentUpdatedPropertyName], action.payload.data],
        lawFirmInfoFields: { ...defaultState.lawFirmInfoFields },
      };
    case types.UPDATE_POA_INFO_FIELDS:
      return {
        ...state,
        loading: false,
        loadingInModal: false,
        errorInModal: null,
        lawFirmInfoFields:
          Object.keys(action.payload).length === 0
            ? defaultState.lawFirmInfoFields
            : {
                ...state.lawFirmInfoFields,
                ...action.payload,
              },
      };
    case types.DELETE_POA_INFO_ITEM:
      return {
        ...state,
        loading: false,
      };

    case types.UPDATE_DISPUTE_APPLICATION_DATA:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };

    case types.FETCH_LOOKUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        lookups: {
          ...state.lookups,
          ...action.payload,
        },
      };

    case types.ADD_TO_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.GET_MULTIPLE_PROPERTIES:
      return {
        ...state,
        multipleProperties: {
          ...action.payload,
        },
        loading: false,
      };
    case types.FETCH_PROPERTY_OWNER_BY_EID_SUCCESS:
      return {
        ...state,
        loading: false,
        PropertyOwnerByEid: action.payload,
      };
    case types.RESET_PROPERTY_OWNER_BY_EID:
      return {
        ...state,
        PropertyOwnerByEid: {},
      };

    case types.FETCH_REPRESENTATIVE_DETAILS_SUCCESS:
      return {
        ...state,
        loadingInModal: false,
        represntativeDetails: action.payload,
      };
    case types.UPDATE_REPRESENTATIVE_FETCHED_DATA:
      return {
        ...state,
        loadingInModal: false,
        represntativeDetails: action.payload,
      };
    case types.MANUAL_ADDRESS_ADDED_SUCCESS:
      return {
        ...state,
        loading: false,
        manualProperties: [...state.manualProperties, ...action.payload],
      };
    case types.SET_ACTIVE_UPDATING_LAW_FIRM:
      return {
        ...state,
        activeUpdatingLawFirmId: action.payload,
      };
    case types.SET_ACTIVE_PLAINTIFF_ID:
      return {
        ...state,
        activePlaintiffId: action.payload,
      };

    default:
      return state;
  }
}
